export default class Device {
  constructor(makeMobxStore) {
    this.reset = makeMobxStore(this);
  }
  set = {
    size: (size = "") => {
      this.size = size;
    },
    scrolling: (scrolling = false) => {
      this.scrolling = scrolling;
    }
  };
  get isPhone() {
    return this.size === "compact" || this.size === "medium";
  }
  get isTablet() {
    return this.size === "expanded";
  }
  get isDesktop() {
    return this.size === "large" || this.size === "extraLarge";
  }
  get isTouch() {
    return !!navigator.maxTouchPoints;
  }
  get iOS() {
    return (
      window.navigator.maxTouchPoints &&
      (this.isPhone || this.isTablet) &&
      window.navigator.vendor.includes("Apple Computer")
    );
  }
  get measured() {
    return this.size !== "";
  }
}
